//! the following enums are used to handle currency across the platform, but are not automatically populated during a migration
//! they are populated through a cron job located in the API on a time interval (every 24 hours)
/* [`CurrencyCode` Enum](https://shopify.dev/docs/api/admin-graphql/2024-10/enums/CurrencyCode) */
export const CurrencyCode = {
    // United Arab Emirates Dirham (AED).
    AED: 'AED',
    // Afghan Afghani (AFN).
    AFN: 'AFN',
    // Albanian Lek (ALL).
    ALL: 'ALL',
    // Armenian Dram (AMD).
    AMD: 'AMD',
    // Netherlands Antillean Guilder.
    ANG: 'ANG',
    // Angolan Kwanza (AOA).
    AOA: 'AOA',
    // Argentine Pesos (ARS).
    ARS: 'ARS',
    // Australian Dollars (AUD).
    AUD: 'AUD',
    // Aruban Florin (AWG).
    AWG: 'AWG',
    // Azerbaijani Manat (AZN).
    AZN: 'AZN',
    // Bosnia and Herzegovina Convertible Mark (BAM).
    BAM: 'BAM',
    // Barbadian Dollar (BBD).
    BBD: 'BBD',
    // Bangladesh Taka (BDT).
    BDT: 'BDT',
    // Bulgarian Lev (BGN).
    BGN: 'BGN',
    // Bahraini Dinar (BHD).
    BHD: 'BHD',
    // Burundian Franc (BIF).
    BIF: 'BIF',
    // Bermudian Dollar (BMD).
    BMD: 'BMD',
    // Brunei Dollar (BND).
    BND: 'BND',
    // Bolivian Boliviano (BOB).
    BOB: 'BOB',
    // Brazilian Real (BRL).
    BRL: 'BRL',
    // Bahamian Dollar (BSD).
    BSD: 'BSD',
    // Bhutanese Ngultrum (BTN).
    BTN: 'BTN',
    // Botswana Pula (BWP).
    BWP: 'BWP',
    // Belarusian Ruble (BYN).
    BYN: 'BYN',
    // Belize Dollar (BZD).
    BZD: 'BZD',
    // Canadian Dollars (CAD).
    CAD: 'CAD',
    // Congolese franc (CDF).
    CDF: 'CDF',
    // Swiss Francs (CHF).
    CHF: 'CHF',
    // Chilean Peso (CLP).
    CLP: 'CLP',
    // Chinese Yuan Renminbi (CNY).
    CNY: 'CNY',
    // Colombian Peso (COP).
    COP: 'COP',
    // Costa Rican Colones (CRC).
    CRC: 'CRC',
    // Cape Verdean escudo (CVE).
    CVE: 'CVE',
    // Czech Koruny (CZK).
    CZK: 'CZK',
    // Djiboutian Franc (DJF).
    DJF: 'DJF',
    // Danish Kroner (DKK).
    DKK: 'DKK',
    // Dominican Peso (DOP).
    DOP: 'DOP',
    // Algerian Dinar (DZD).
    DZD: 'DZD',
    // Egyptian Pound (EGP).
    EGP: 'EGP',
    // Eritrean Nakfa (ERN).
    ERN: 'ERN',
    // Ethiopian Birr (ETB).
    ETB: 'ETB',
    // Euro (EUR).
    EUR: 'EUR',
    // Fijian Dollars (FJD).
    FJD: 'FJD',
    // Falkland Islands Pounds (FKP).
    FKP: 'FKP',
    // United Kingdom Pounds (GBP).
    GBP: 'GBP',
    // Georgian Lari (GEL).
    GEL: 'GEL',
    // Ghanaian Cedi (GHS).
    GHS: 'GHS',
    // Gibraltar Pounds (GIP).
    GIP: 'GIP',
    // Gambian Dalasi (GMD).
    GMD: 'GMD',
    // Guinean Franc (GNF).
    GNF: 'GNF',
    // Guatemalan Quetzal (GTQ).
    GTQ: 'GTQ',
    // Guyanese Dollar (GYD).
    GYD: 'GYD',
    // Hong Kong Dollars (HKD).
    HKD: 'HKD',
    // Honduran Lempira (HNL).
    HNL: 'HNL',
    // Croatian Kuna (HRK).
    HRK: 'HRK',
    // Haitian Gourde (HTG).
    HTG: 'HTG',
    // Hungarian Forint (HUF).
    HUF: 'HUF',
    // Indonesian Rupiah (IDR).
    IDR: 'IDR',
    // Israeli New Shekel (NIS).
    ILS: 'ILS',
    // Indian Rupees (INR).
    INR: 'INR',
    // Iraqi Dinar (IQD).
    IQD: 'IQD',
    // Iranian Rial (IRR).
    IRR: 'IRR',
    // Icelandic Kronur (ISK).
    ISK: 'ISK',
    // Jersey Pound.
    JEP: 'JEP',
    // Jamaican Dollars (JMD).
    JMD: 'JMD',
    // Jordanian Dinar (JOD).
    JOD: 'JOD',
    // Japanese Yen (JPY).
    JPY: 'JPY',
    // Kenyan Shilling (KES).
    KES: 'KES',
    // Kyrgyzstani Som (KGS).
    KGS: 'KGS',
    // Cambodian Riel.
    KHR: 'KHR',
    // Kiribati Dollar (KID).
    KID: 'KID',
    // Comorian Franc (KMF).
    KMF: 'KMF',
    // South Korean Won (KRW).
    KRW: 'KRW',
    // Kuwaiti Dinar (KWD).
    KWD: 'KWD',
    // Cayman Dollars (KYD).
    KYD: 'KYD',
    // Kazakhstani Tenge (KZT).
    KZT: 'KZT',
    // Laotian Kip (LAK).
    LAK: 'LAK',
    // Lebanese Pounds (LBP).
    LBP: 'LBP',
    // Sri Lankan Rupees (LKR).
    LKR: 'LKR',
    // Liberian Dollar (LRD).
    LRD: 'LRD',
    // Lesotho Loti (LSL).
    LSL: 'LSL',
    // Lithuanian Litai (LTL).
    LTL: 'LTL',
    // Latvian Lati (LVL).
    LVL: 'LVL',
    // Libyan Dinar (LYD).
    LYD: 'LYD',
    // Moroccan Dirham.
    MAD: 'MAD',
    // Moldovan Leu (MDL).
    MDL: 'MDL',
    // Malagasy Ariary (MGA).
    MGA: 'MGA',
    // Macedonia Denar (MKD).
    MKD: 'MKD',
    // Burmese Kyat (MMK).
    MMK: 'MMK',
    // Mongolian Tugrik.
    MNT: 'MNT',
    // Macanese Pataca (MOP).
    MOP: 'MOP',
    // Mauritanian Ouguiya (MRU).
    MRU: 'MRU',
    // Mauritian Rupee (MUR).
    MUR: 'MUR',
    // Maldivian Rufiyaa (MVR).
    MVR: 'MVR',
    // Malawian Kwacha (MWK).
    MWK: 'MWK',
    // Mexican Pesos (MXN).
    MXN: 'MXN',
    // Malaysian Ringgits (MYR).
    MYR: 'MYR',
    // Mozambican Metical.
    MZN: 'MZN',
    // Namibian Dollar.
    NAD: 'NAD',
    // Nigerian Naira (NGN).
    NGN: 'NGN',
    // Nicaraguan Córdoba (NIO).
    NIO: 'NIO',
    // Norwegian Kroner (NOK).
    NOK: 'NOK',
    // Nepalese Rupee (NPR).
    NPR: 'NPR',
    // New Zealand Dollars (NZD).
    NZD: 'NZD',
    // Omani Rial (OMR).
    OMR: 'OMR',
    // Panamian Balboa (PAB).
    PAB: 'PAB',
    // Peruvian Nuevo Sol (PEN).
    PEN: 'PEN',
    // Papua New Guinean Kina (PGK).
    PGK: 'PGK',
    // Philippine Peso (PHP).
    PHP: 'PHP',
    // Pakistani Rupee (PKR).
    PKR: 'PKR',
    // Polish Zlotych (PLN).
    PLN: 'PLN',
    // Paraguayan Guarani (PYG).
    PYG: 'PYG',
    // Qatari Rial (QAR).
    QAR: 'QAR',
    // Romanian Lei (RON).
    RON: 'RON',
    // Serbian dinar (RSD).
    RSD: 'RSD',
    // Russian Rubles (RUB).
    RUB: 'RUB',
    // Rwandan Franc (RWF).
    RWF: 'RWF',
    // Saudi Riyal (SAR).
    SAR: 'SAR',
    // Solomon Islands Dollar (SBD).
    SBD: 'SBD',
    // Seychellois Rupee (SCR).
    SCR: 'SCR',
    // Sudanese Pound (SDG).
    SDG: 'SDG',
    // Swedish Kronor (SEK).
    SEK: 'SEK',
    // Singapore Dollars (SGD).
    SGD: 'SGD',
    // Saint Helena Pounds (SHP).
    SHP: 'SHP',
    // Sierra Leonean Leone (SLL).
    SLL: 'SLL',
    // Somali Shilling (SOS).
    SOS: 'SOS',
    // Surinamese Dollar (SRD).
    SRD: 'SRD',
    // South Sudanese Pound (SSP).
    SSP: 'SSP',
    // Sao Tome And Principe Dobra (STN).
    STN: 'STN',
    // Syrian Pound (SYP).
    SYP: 'SYP',
    // Swazi Lilangeni (SZL).
    SZL: 'SZL',
    // Thai baht (THB).
    THB: 'THB',
    // Tajikistani Somoni (TJS).
    TJS: 'TJS',
    // Turkmenistani Manat (TMT).
    TMT: 'TMT',
    // Tunisian Dinar (TND).
    TND: 'TND',
    // Tongan Pa'anga (TOP).
    TOP: 'TOP',
    // Turkish Lira (TRY).
    TRY: 'TRY',
    // Trinidad and Tobago Dollars (TTD).
    TTD: 'TTD',
    // Taiwan Dollars (TWD).
    TWD: 'TWD',
    // Tanzanian Shilling (TZS).
    TZS: 'TZS',
    // Ukrainian Hryvnia (UAH).
    UAH: 'UAH',
    // Ugandan Shilling (UGX).
    UGX: 'UGX',
    // United States Dollars (USD).
    USD: 'USD',
    // Uruguayan Pesos (UYU).
    UYU: 'UYU',
    // Uzbekistan som (UZS).
    UZS: 'UZS',
    // Venezuelan Bolivares (VED).
    VED: 'VED',
    // Venezuelan Bolivares Soberanos (VES).
    VES: 'VES',
    // Vietnamese đồng (VND).
    VND: 'VND',
    // Vanuatu Vatu (VUV).
    VUV: 'VUV',
    // Samoan Tala (WST).
    WST: 'WST',
    // Central African CFA Franc (XAF).
    XAF: 'XAF',
    // East Caribbean Dollar (XCD).
    XCD: 'XCD',
    // West African CFA franc (XOF).
    XOF: 'XOF',
    // CFP Franc (XPF).
    XPF: 'XPF',
    // Unrecognized currency.
    XXX: 'XXX',
    // Yemeni Rial (YER).
    YER: 'YER',
    // South African Rand (ZAR).
    ZAR: 'ZAR',
    // Zambian Kwacha (ZMW).
    ZMW: 'ZMW',
    // Belarusian Ruble (BYR).
    BYR: 'BYR',
    // Sao Tome And Principe Dobra (STD).
    STD: 'STD',
    // Venezuelan Bolivares (VEF).
    VEF: 'VEF',
};
export const CorsoSupportedCurrency = {
    [CurrencyCode.USD]: CurrencyCode.USD,
    [CurrencyCode.CAD]: CurrencyCode.CAD,
    [CurrencyCode.GBP]: CurrencyCode.GBP,
    [CurrencyCode.EUR]: CurrencyCode.EUR,
    [CurrencyCode.AUD]: CurrencyCode.AUD,
    [CurrencyCode.JPY]: CurrencyCode.JPY,
    [CurrencyCode.NZD]: CurrencyCode.NZD,
    [CurrencyCode.CHF]: CurrencyCode.CHF,
    [CurrencyCode.MXN]: CurrencyCode.MXN,
    [CurrencyCode.CLP]: CurrencyCode.CLP,
};
export const currencyCodeNames = {
    [CurrencyCode.AED]: 'United Arab Emirates dirham',
    [CurrencyCode.AFN]: 'Afghan afghani',
    [CurrencyCode.ALL]: 'Albanian lek',
    [CurrencyCode.AMD]: 'Armenian dram',
    [CurrencyCode.ANG]: 'Netherlands Antillean guilder',
    [CurrencyCode.AOA]: 'Angolan kwanza',
    [CurrencyCode.ARS]: 'Argentine peso',
    [CurrencyCode.AUD]: 'Australian Dollar',
    [CurrencyCode.AWG]: 'Aruban florin',
    [CurrencyCode.AZN]: 'Azerbaijani manat',
    [CurrencyCode.BAM]: 'Bosnia and Herzegovina convertible mark',
    [CurrencyCode.BBD]: 'Barbados dollar',
    [CurrencyCode.BDT]: 'Bangladeshi taka',
    [CurrencyCode.BGN]: 'Bulgarian lev',
    [CurrencyCode.BHD]: 'Bahraini dinar',
    [CurrencyCode.BIF]: 'Burundian franc',
    [CurrencyCode.BMD]: 'Bermudian dollar',
    [CurrencyCode.BND]: 'Brunei dollar',
    [CurrencyCode.BOB]: 'Boliviano',
    [CurrencyCode.BRL]: 'Brazilian real',
    [CurrencyCode.BSD]: 'Bahamian dollar',
    [CurrencyCode.BTN]: 'Bhutanese ngultrum',
    [CurrencyCode.BWP]: 'Botswana pula',
    [CurrencyCode.BYN]: 'Belarusian ruble',
    [CurrencyCode.BZD]: 'Belize dollar',
    [CurrencyCode.CAD]: 'Canadian Dollar',
    [CurrencyCode.CDF]: 'Congolese franc',
    [CurrencyCode.CHF]: 'Swiss Franc',
    [CurrencyCode.CLP]: 'Chilean Peso',
    [CurrencyCode.COP]: 'Colombian peso',
    [CurrencyCode.CRC]: 'Costa Rican colon',
    [CurrencyCode.CVE]: 'Cape Verdean escudo',
    [CurrencyCode.CZK]: 'Czech koruna',
    [CurrencyCode.DJF]: 'Djiboutian franc',
    [CurrencyCode.DKK]: 'Danish krone',
    [CurrencyCode.DOP]: 'Dominican peso',
    [CurrencyCode.DZD]: 'Algerian dinar',
    [CurrencyCode.EGP]: 'Egyptian pound',
    [CurrencyCode.ERN]: 'Eritrean nakfa',
    [CurrencyCode.ETB]: 'Ethiopian birr',
    [CurrencyCode.EUR]: 'Euro',
    [CurrencyCode.FJD]: 'Fiji dollar',
    [CurrencyCode.FKP]: 'Falkland Islands pound',
    [CurrencyCode.GBP]: 'British Pound',
    [CurrencyCode.GEL]: 'Georgian lari',
    [CurrencyCode.GHS]: 'Ghanaian cedi',
    [CurrencyCode.GIP]: 'Gibraltar pound',
    [CurrencyCode.GMD]: 'Gambian dalasi',
    [CurrencyCode.GNF]: 'Guinean franc',
    [CurrencyCode.GTQ]: 'Guatemalan quetzal',
    [CurrencyCode.GYD]: 'Guyanese dollar',
    [CurrencyCode.HKD]: 'Hong Kong dollar',
    [CurrencyCode.HNL]: 'Honduran lempira',
    [CurrencyCode.HTG]: 'Haitian gourde',
    [CurrencyCode.HUF]: 'Hungarian forint',
    [CurrencyCode.IDR]: 'Indonesian rupiah',
    [CurrencyCode.ILS]: 'Israeli new shekel',
    [CurrencyCode.INR]: 'Indian rupee',
    [CurrencyCode.IQD]: 'Iraqi dinar',
    [CurrencyCode.IRR]: 'Iranian rial',
    [CurrencyCode.ISK]: 'Icelandic króna (plural: krónur)',
    [CurrencyCode.JMD]: 'Jamaican dollar',
    [CurrencyCode.JOD]: 'Jordanian dinar',
    [CurrencyCode.JPY]: 'Japanese Yen',
    [CurrencyCode.KES]: 'Kenyan shilling',
    [CurrencyCode.KGS]: 'Kyrgyzstani som',
    [CurrencyCode.KHR]: 'Cambodian riel',
    [CurrencyCode.KMF]: 'Comoro franc',
    [CurrencyCode.KRW]: 'South Korean won',
    [CurrencyCode.KWD]: 'Kuwaiti dinar',
    [CurrencyCode.KYD]: 'Cayman Islands dollar',
    [CurrencyCode.KZT]: 'Kazakhstani tenge',
    [CurrencyCode.LAK]: 'Lao kip',
    [CurrencyCode.LBP]: 'Lebanese pound',
    [CurrencyCode.LKR]: 'Sri Lankan rupee',
    [CurrencyCode.LRD]: 'Liberian dollar',
    [CurrencyCode.LSL]: 'Lesotho loti',
    [CurrencyCode.LYD]: 'Libyan dinar',
    [CurrencyCode.MAD]: 'Moroccan dirham',
    [CurrencyCode.MDL]: 'Moldovan leu',
    [CurrencyCode.MGA]: 'Malagasy ariary',
    [CurrencyCode.MKD]: 'Macedonian denar',
    [CurrencyCode.MMK]: 'Myanmar kyat',
    [CurrencyCode.MNT]: 'Mongolian tögrög',
    [CurrencyCode.MOP]: 'Macanese pataca',
    [CurrencyCode.MRU]: 'Mauritanian ouguiya',
    [CurrencyCode.MUR]: 'Mauritian rupee',
    [CurrencyCode.MVR]: 'Maldivian rufiyaa',
    [CurrencyCode.MWK]: 'Malawian kwacha',
    [CurrencyCode.MXN]: 'Mexican Peso',
    [CurrencyCode.MYR]: 'Malaysian ringgit',
    [CurrencyCode.MZN]: 'Mozambican metical',
    [CurrencyCode.NAD]: 'Namibian dollar',
    [CurrencyCode.NGN]: 'Nigerian naira',
    [CurrencyCode.NIO]: 'Nicaraguan córdoba',
    [CurrencyCode.NOK]: 'Norwegian krone',
    [CurrencyCode.NPR]: 'Nepalese rupee',
    [CurrencyCode.NZD]: 'New Zealand Dollar',
    [CurrencyCode.OMR]: 'Omani rial',
    [CurrencyCode.PAB]: 'Panamanian balboa',
    [CurrencyCode.PEN]: 'Peruvian sol',
    [CurrencyCode.PGK]: 'Papua New Guinean kina',
    [CurrencyCode.PHP]: 'Philippine peso[10]',
    [CurrencyCode.PKR]: 'Pakistani rupee',
    [CurrencyCode.PLN]: 'Polish złoty',
    [CurrencyCode.PYG]: 'Paraguayan guaraní',
    [CurrencyCode.QAR]: 'Qatari riyal',
    [CurrencyCode.RON]: 'Romanian leu',
    [CurrencyCode.RSD]: 'Serbian dinar',
    [CurrencyCode.CNY]: 'Renminbi[11]',
    [CurrencyCode.RUB]: 'Russian ruble',
    [CurrencyCode.RWF]: 'Rwandan franc',
    [CurrencyCode.SAR]: 'Saudi riyal',
    [CurrencyCode.SBD]: 'Solomon Islands dollar',
    [CurrencyCode.SCR]: 'Seychelles rupee',
    [CurrencyCode.SDG]: 'Sudanese pound',
    [CurrencyCode.SEK]: 'Swedish krona (plural: kronor)',
    [CurrencyCode.SGD]: 'Singapore dollar',
    [CurrencyCode.SHP]: 'Saint Helena pound',
    [CurrencyCode.SLL]: 'Sierra Leonean leone (old leone)[12][13][14][15]',
    [CurrencyCode.SOS]: 'Somali shilling',
    [CurrencyCode.SRD]: 'Surinamese dollar',
    [CurrencyCode.SSP]: 'South Sudanese pound',
    [CurrencyCode.STN]: 'São Tomé and Príncipe dobra',
    [CurrencyCode.SYP]: 'Syrian pound',
    [CurrencyCode.SZL]: 'Swazi lilangeni',
    [CurrencyCode.THB]: 'Thai baht',
    [CurrencyCode.TJS]: 'Tajikistani somoni',
    [CurrencyCode.TMT]: 'Turkmenistan manat',
    [CurrencyCode.TND]: 'Tunisian dinar',
    [CurrencyCode.TOP]: 'Tongan paʻanga',
    [CurrencyCode.TRY]: 'Turkish lira',
    [CurrencyCode.TTD]: 'Trinidad and Tobago dollar',
    [CurrencyCode.TWD]: 'New Taiwan dollar',
    [CurrencyCode.TZS]: 'Tanzanian shilling',
    [CurrencyCode.UAH]: 'Ukrainian hryvnia',
    [CurrencyCode.UGX]: 'Ugandan shilling',
    [CurrencyCode.USD]: 'United States Dollar',
    [CurrencyCode.UYU]: 'Uruguayan peso',
    [CurrencyCode.UZS]: 'Uzbekistan sum',
    [CurrencyCode.VED]: 'Venezuelan digital bolívar',
    [CurrencyCode.VES]: 'Venezuelan sovereign bolívar',
    [CurrencyCode.VND]: 'Vietnamese đồng',
    [CurrencyCode.VUV]: 'Vanuatu vatu',
    [CurrencyCode.WST]: 'Samoan tala',
    [CurrencyCode.XAF]: 'CFA franc BEAC',
    [CurrencyCode.XCD]: 'East Caribbean dollar',
    [CurrencyCode.XOF]: 'CFA franc BCEAO',
    [CurrencyCode.XPF]: 'CFP franc (franc Pacifique)',
    [CurrencyCode.XXX]: 'No currency',
    [CurrencyCode.YER]: 'Yemeni rial',
    [CurrencyCode.ZAR]: 'South African rand',
    [CurrencyCode.ZMW]: 'Zambian kwacha',
    [CurrencyCode.LVL]: 'Latvian lats',
    [CurrencyCode.BYR]: 'Belarusian ruble',
    [CurrencyCode.LTL]: 'Lithuanian litas',
    [CurrencyCode.STD]: 'São Tomé and Príncipe dobra',
    [CurrencyCode.VEF]: 'Venezuelan bolívar',
    [CurrencyCode.HRK]: 'Croatian kuna',
    [CurrencyCode.JEP]: 'Jersey pound',
    [CurrencyCode.KID]: 'Kiribati dollar',
};
//# sourceMappingURL=currency.js.map